import {
  User,
  MetaInfo,
  UserName,
  Location
} from './Styles'

import Avatar from 'components/Avatar'
import PinIcon from 'components/StaticIcons/Pin'

import { IUser } from 'interfaces/IUser';

interface props {
  user: IUser;
}

export function UserMeta({ user: { name, location, avatar: { src, size = 'middle' } } }: props) {
  return (
    <User>
      <Avatar size={size} src={src} />
      <MetaInfo>
        <UserName>{name}</UserName>
        {location && <Location><PinIcon /> {location}</Location>}
      </MetaInfo>
    </User>
  )
}